<template>
  <div class="profile-layout">
    <div class="profile-layout__side-bar">
      <SideBarMenu v-if="!isMobile()" :name-prefix="getNamePrefix" />
      <template v-else>
        <img src="@/assets/images/svg/burger.svg"
             alt="burger menu"
             class="profile-layout__side-bar__menu-icon"
             @click.stop="toggleSideBarMenuMobile"
        />
        <div v-if="isSideBarMobileOpen" class="profile-layout__side-bar__mobile">
          <SideBarMenu :name-prefix="getNamePrefix" />
        </div>
      </template>
    </div>
    <div class="profile-layout__container">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { isMobile } from '@/helpers/media'
import SideBarMenu from "@/components/ui/molecules/SideBarMenu";

export default {
  name: "ProfileLayout",
  components: { SideBarMenu },
  data() {
    return {
      isSideBarMobileOpen: false,
      namePrefix: null
    }
  },
  computed: {
    ...mapGetters({
      getCurrentUser: 'getCurrentUser'
    }),
    getNamePrefix() {
      const { name, family_name } = this.getCurrentUser
      return name && family_name ? name.charAt(0).toUpperCase() + family_name.charAt(0).toUpperCase() : ''
    }
  },
  mounted() {
    document.addEventListener('click', () => {
      this.isSideBarMobileOpen = false
    })
  },
  methods: {
    ...mapActions({
      setIsLoading: 'setIsLoading'
    }),
    isMobile,
    toggleSideBarMenuMobile() {
      this.isSideBarMobileOpen = !this.isSideBarMobileOpen
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-layout {
  height: 100vh;
  display: flex;

  &__container {
    width: 100vw;
  }

  &__side-bar {

    &__menu-icon {
      position: fixed;
      width: 2.5rem;
      height: 2.5rem;
      top: 0.5rem;
      left: 0.5rem;
      z-index: 3;
    }

    &__mobile {
      height: 100vh;
      position: absolute;
      left: 0;
      background: #F4F7F8;
      z-index: 2;
    }

  }

}
</style>